import { Typography } from '@breetometer/components';
import { isConversions, isEdits, isWithdrawals, type ITransactionHistory, type TransactionHistoryType } from 'BreetHelpers';

import { getTransactionEditsType, type ITableColumnType } from '../../WalletTransactions.helpers';

const TableColumnType = ({ row }: ITableColumnType) => {
	const getTypeText = (transaction: ITransactionHistory<TransactionHistoryType>): string => {
		if (isWithdrawals(transaction)) {
			const { meta } = transaction.doc;
			return meta.type === 'address' ? 'Crypto' : 'Withdrawals';
		}
		if (isConversions(transaction)) {
			return `${transaction.doc.from?.toUpperCase() ?? 'Unknown'} Conversions`;
		}
		if (isEdits(transaction)) {
			return getTransactionEditsType(transaction);
		}
		return '...';
	};

	return <Typography as='p'>{getTypeText(row)}</Typography>;
};

export default TableColumnType;
